import { EntryType } from "@/openapi/generated/models";
import { QueryKeys } from "@/lib/types";

export const TEACHER_PROFILE_IMAGE_QUERY_SUFFIX = "profile-image" as const;

export function getTeacherProfileImageQueryKey(
  tenantId: number,
  teacherId: number,
) {
  return [
    QueryKeys.MediaAsset,
    tenantId,
    EntryType.Teacher,
    teacherId,
    TEACHER_PROFILE_IMAGE_QUERY_SUFFIX,
  ] as const;
}

export function getTeacherMediaQueryPrefix(
  tenantId: number,
  teacherId: number,
) {
  return [
    QueryKeys.MediaAsset,
    tenantId,
    EntryType.Teacher,
    teacherId,
  ] as const;
}
